import { hasClassElement } from '@jspartials/class-list-utils';
import {
  addClassToElement,
  removeClassToElement,
  classes
} from '../../partials/class-list-utils';
import { mediaQuery, getMediaQuery } from '@jspartials/general-utils';

const selectors = {
  carouselInnerContent: '.js-carousel__inner',
  zoomedImage: '.js-image-fullscreen',
  hiddenClass: 'tw-hidden'
};

const mediaQueryTablet = getMediaQuery(mediaQuery.tablet);

const startZoom = () => {
  const carouselInnerContent = document.querySelector(
    selectors.carouselInnerContent
  );
  if (carouselInnerContent) {
    const carouselItems = carouselInnerContent.querySelectorAll('li');

    for (const item of carouselItems) {
      item.addEventListener('click', function (event) {
        if (mediaQueryTablet.matches) {
          const zoomedImage = item.querySelector(selectors.zoomedImage);
          const itemPicture = item.querySelector('picture');
          const fullResImageUrl = item.getAttribute('data-fullscreen-image');

          if (!zoomedImage || !itemPicture || !fullResImageUrl) return;

          function panEvent(event) {
            pan(event, item, zoomedImage);
          }

          if (hasClassElement(item, classes.is.zoomed)) {
            unzoom(zoomedImage, item, panEvent);
          } else {
            zoom(
              item,
              zoomedImage,
              fullResImageUrl,
              itemPicture,
              event,
              panEvent
            );
          }

          item.addEventListener('mouseleave', function () {
            unzoom(zoomedImage, item, panEvent);
          });
        }
      });
    }
  }
};

const zoom = (
  item,
  zoomedImage,
  fullResImageUrl,
  itemPicture,
  event,
  panEvent
) => {
  const rect = item.getBoundingClientRect();
  const x = -(event.clientX - rect.left - rect.width / 2);
  const y = -(event.clientY - rect.top - rect.height / 2);

  addClassToElement(item, classes.is.zoomed);
  zoomedImage.style.transform = `translate(${x}px, ${y}px) scale(2)`;
  zoomedImage.src = fullResImageUrl;
  removeClassToElement(zoomedImage, selectors.hiddenClass);
  addClassToElement(itemPicture, selectors.hiddenClass);

  item.addEventListener('mousemove', panEvent);
};

const unzoom = (zoomedImage, item, panEvent) => {
  zoomedImage.style.transform = 'scale(1)';
  removeClassToElement(item, classes.is.zoomed);
  item.removeEventListener('mousemove', panEvent);
};

const pan = (e, item, zoomedImage) => {
  if (hasClassElement(item, classes.is.zoomed)) {
    const rect = item.getBoundingClientRect();
    // Mouse position
    const x = -(e.clientX - rect.left - rect.width / 2);
    const y = -(e.clientY - rect.top - rect.height / 2);
    zoomedImage.style.transform = `translate(${x}px, ${y}px) scale(2)`;
  }
};

export { startZoom };
